import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createAuthenticatedApiInstance } from 'src/utils/api';
import { CommunityMetrics } from 'src/modules/community/communityMetrics/types';

export const initialState: CommunityMetrics = {
  growth: {
    newMembers: {
      dates: [],
      status: 'idle',
      values: [],
    },
  },
};

export const communityMetricsSlice = createSlice({
  name: 'communityMetrics',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchNewMembersMetrics.pending, (state) => {
        state.growth.newMembers.status = 'loading';
      })
      .addCase(fetchNewMembersMetrics.fulfilled, (state, action) => {
        const slug = action.payload.slug;
        state.growth.newMembers.status = 'succeeded';
        state.growth.newMembers.dates = action.payload.data?.[slug]?.map(month => month.date) || [];
        state.growth.newMembers.values = action.payload.data?.[slug]?.map(month => month.value) || [];
      });
  },
});

export default communityMetricsSlice.reducer;

export const fetchNewMembersMetrics = createAsyncThunk(
  'communityMetrics/fetchNewMembersMetrics',
  async (slug: string, thunkApi) => {
    const api = createAuthenticatedApiInstance(thunkApi.getState);

    try {
      const { data } = await api.get(`private/communities/${slug}/metrics/NewMembersMonthly`);
      return { data, slug };
    } catch (err) {
      // A failed request or error in a thunk will never return a rejected promise.
      // As we want to log in the errors/reason/status of the failed request to Sentry,
      // we need to return a new value using the thunkAPI.rejectWithValue utility.
      return thunkApi.rejectWithValue(err);
    }
  },
);
